import "./Footer.scss";
import facebook from "../../assets/images/facebook.png";
import twitter from "../../assets/images/twitter.png";
import linkedin from "../../assets/images/linkedin.png";
import x from "../../assets/images/x.png";
import ig from "../../assets/images/ig.png";
const Footer = () => {
  return (
    <div className="footer">
      <div className="container footer-col">
        <div>
          <div className="title">Reach Our Representatives</div>
          <a href="/Connect">
            <button>CONTACT US</button>
          </a>
        </div>
        <div>
          <div className="footer-row">
            <div id="followus">Follow us on</div>
            <div className="custom-row">
              <a
                href="https://www.facebook.com/moelagos/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  alt="facebook"
                  src={facebook}
                  className="socialmediaicon"
                  href="https://www.facebook.com/moelagos/
"
                />
              </a>
              <a href="https://x.com/LasgMOE" target="_blank" rel="noreferrer">
                <img
                  alt="twitter"
                  src={x}
                  className="socialmediaicon"
                  href="https://x.com/LasgMOE"
                />
              </a>
              <a
                href="https://www.instagram.com/lagosmoe/"
                target="_blank"
                rel="noreferrer"
              >
                <img alt="linkedin" src={ig} className="socialmediaicon" />
              </a>
            </div>
          </div>
          <div className="allrights">
            © All rights reserved to LAGOS STATE GOVERNMENT 2025
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
